/**
 * External dependencies
 */
import page from 'page';

/**
 * internal dependencies
 */
import { NAVIGATE } from "./action-types";

export const navigationMiddleware = store => {
    return next => action => {
        switch (action.type) {
            case NAVIGATE:
                if (action.path) {
                    page(action.path);
                }
                return next(action);
            default:
                return next(action);
        }
    }
}

export default navigationMiddleware;